import manageKeyBindings from "@/mixins/manageKeyBindings";
import vmodal from "@/packages/vmodal";
import Echo from "laravel-echo";
import moment from "moment";
import {extendMoment} from "moment-range";
import Pusher from "pusher-js";
import Vue from "vue";
import VueTheMask from "vue-the-mask";
import router from "./apps/clientPortal/router";
import store from "./apps/clientPortal/store";
import Http from "./classes/Http";
import authed from "./mixins/authed";
import checkRoute from "./mixins/checkRoute";
import detect from "./mixins/detect";
import enums from "./mixins/enums";
import form from "./mixins/form";
import permissions from "./mixins/permissions";
import present from "./mixins/present";
import refs from "./mixins/refs";
import route from "./mixins/route";
import scrollTo from "./mixins/scrollTo";
import setScrollSize from "./mixins/setScrollSize";
import tenant from "./mixins/tenant";
import stringerMixin from "./packages/stringer/src/StringerMixin";

window.moment = extendMoment(moment);
window.http = new Http("httpClient");
window.Pusher = Pusher;
window.Echo = new Echo({
	broadcaster: "reverb",
	key: window.socketsConfig.appKey,
	wsHost: window.socketsConfig.domain,
	// wsPort: window.socketsConfig.port,
	// wssPort: window.socketsConfig.port,
	// forceTLS: (window.socketsConfig.scheme ?? "https") === "https",
	// enabledTransports: ["ws", "wss"],
	authorizer: (channel, options) => {
		return {
			authorize: (socketId, callback) => {
				http().post(window.endpoints.broadcasting, {
					socket_id: socketId,
					channel_name: channel.name,
				})
					.then(response => {
						callback(false, response.data);
					})
					.catch(error => {
						callback(true, error);
					});
			},
		};
	},
});
window.externalHttp = new Http("externalHttpClient");
window._ = require("lodash");
window.Qs = require("qs");
window.tween = require("@tweenjs/tween.js");
window.dayjs = require("dayjs");
window.dayjs.extend(require("dayjs/plugin/duration"));
window.dayjs.extend(require("dayjs/plugin/relativeTime"));

// Vue.component("loading-layout", require("./apps/clientPortal/layouts/Loading").default);
// Vue.component("auth-layout", require("./apps/clientPortal/layouts/Auth").default);
// Vue.component("noAuth-layout", require("./apps/clientPortal/layouts/NoAuth").default);
// Vue.component("default-layout", require("./apps/clientPortal/layouts/Portal").default);
// Vue.component("error-layout", require("./layouts/Error").default);
Vue.component("app", require("./apps/clientPortal/App").default);
Vue.component("info-button", require("./apps/clientPortal/components/InfoButton").default);
Vue.component("alert", require("./components/Alert").default);
Vue.component("alert-container", require("./components/AlertContainer").default);
Vue.component("loader", require("./components/GenericLoader").default);
// Vue.component("v-datepicker", require("./common/components/v-datepicker/v-datepicker").default);
// Vue.component("v-datepicker-calendar", require("./common/components/v-datepicker/v-datepicker-calendar").default);
Vue.component("v-dobpicker", require("./common/components/v-dobpicker/v-dobpicker").default);
Vue.component("v-modal", require("./components/v-modal").default);
Vue.component("v-table", require("./common/components/v-table/v-table").default);
Vue.component("v-tabs", require("./common/components/v-tabs/v-tabs").default);
Vue.component("v-tab", require("./common/components/v-tabs/v-tab").default);
Vue.component("v-upload", require("./common/components/v-upload/v-upload").default);
Vue.component("v-filemanager", require("./common/components/v-filemanager/v-filemanager").default);
Vue.component("v-signature", require("./common/components/v-signature/v-signature").default);
Vue.component("v-contextual", require("./common/components/v-contextual/v-contextual.vue").default);
Vue.component("v-contextual-content", require("./common/components/v-contextual/v-contextual-content.vue").default);
Vue.component("v-contextual-option", require("./common/components/v-contextual/v-contextual-option.vue").default);
Vue.component("process-button", require("./components/ProcessButton").default);
Vue.component("progress-indicator", require("./components/ProgressIndicator").default);
Vue.component("status-badge", require("./components/StatusBadge").default);
Vue.component("bool-icon", require("./components/BoolIcon").default);
Vue.component("money", require("./components/Money").default);

Vue.mixin(authed);
Vue.mixin(checkRoute);
Vue.mixin(detect);
Vue.mixin(form(http(), store));
Vue.mixin(enums);
Vue.mixin(permissions);
Vue.mixin(present);
Vue.mixin(refs);
Vue.mixin(route);
Vue.mixin(scrollTo);
Vue.mixin(setScrollSize);
Vue.mixin(stringerMixin);
Vue.mixin(tenant);
Vue.mixin(manageKeyBindings);

Vue.use(vmodal, {
	component: () => import("./components/v-modal.vue"),
	opacity: "1",
	backgroundColor: "rgba(45, 51, 61, .85)",
	animation: "slideBottom",
	isDismisableViaBackgroundClick: false,
});
Vue.use(VueTheMask);

window.router = router;
window.app = new Vue({
	el: "#app",
	router,
	store,
	created() {
		store.dispatch("authStore/authed");
	},
});



